import { useField } from "formik";
import { CheckboxWithLabel, CheckboxWithLabelBaseProps } from "./CheckboxWithLabel";

interface FormikCheckboxWithLabelProps extends CheckboxWithLabelBaseProps {
	name: string;
	checkmarkTop?: string;
	className?: string;
	fontSize?: string;
	initialValue?: boolean;
	label?: string;
	style?: React.CSSProperties;
}

export const FormikCheckboxWithLabel: React.FC<FormikCheckboxWithLabelProps> = ({
	name,
	...props
}) => {
	const [field, meta] = useField<boolean>(name);

	return (
		<CheckboxWithLabel
			{...props}
			name={name}
			checked={!!field.value}
			onChange={field.onChange}
			error={meta.error}
			touched={meta.touched}
		/>
	);
};